module.exports = __webpack_public_path__ + "static/img/paypal.37f9e1fe.svg";